import * as React from 'react';
import TextScreenModal from './TextScreenModal';

export interface TextScreenModalTriggerProps {
  textScreenId?: string;
  textScreenContent?: string;
  renderTrigger: (props: { openModal: () => void }) => React.ReactFragment;
}

interface TextScreenModalTriggerState {
  modalOpen: boolean;
}

export default class TextScreenModalTrigger extends React.Component<
  TextScreenModalTriggerProps,
  TextScreenModalTriggerState
> {
  constructor(props: TextScreenModalTriggerProps) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  openModal = () => this.setState({ modalOpen: true });
  dismissModal = () => this.setState({ modalOpen: false });

  render() {
    const { renderTrigger, ...TextScreenModalProps } = this.props;
    const { modalOpen } = this.state;
    const triggerProps = { openModal: this.openModal };

    return (
      <span>
        {renderTrigger(triggerProps)}
        {modalOpen && (
          <TextScreenModal
            {...TextScreenModalProps}
            contentLabel="Help Dialog"
            isOpen={modalOpen}
            handleClose={this.dismissModal}
          />
        )}
      </span>
    );
  }
}
